export interface SeoResponse {
    id?: string;
    meta_title_en: string;
    meta_title_ar: string;
    meta_description_en: string;
    meta_description_ar: string;
    meta_keywords_en: string;
    meta_keywords_ar: string;
    open_graph_title: string;
    open_graph_description: string;
    open_graph_image_url: string | null;
}
interface Pagination {
    total_records: number;
    total_pages: number;
    limit: number;
    page: number;
}
export interface SeoCategoryKeywordsResponse {
    pagination: Pagination;
    records: SeoCategoryKeywords[];
}
export interface SeoCategoryKeywords {
    id: number;
    slug: string;
    parent_category_id?: number | null;
    name_en: string;
    name_ar: string;
    keywords_en: string;
    keywords_ar: string;
}
export interface SeoCategoryKeywordsInput {
    category_name: string;
    keywords_en: string;
    keywords_ar: string;
}